const SHOW_WMTS_TILE_BOUNDARIES_STORAGE_KEY = "debug.map.showWmtsTileBoundaries";

function loadDebugBoolean(storageKey: string): boolean {
  try {
    return localStorage.getItem(storageKey) === "1";
  } catch {
    return false;
  }
}

let showWmtsTileBoundaries = loadDebugBoolean(SHOW_WMTS_TILE_BOUNDARIES_STORAGE_KEY);

export function getShowWmtsTileBoundariesDebugOption(): boolean {
  return showWmtsTileBoundaries;
}

export function setShowWmtsTileBoundariesDebugOption(enabled: boolean): void {
  showWmtsTileBoundaries = enabled;
  try {
    localStorage.setItem(SHOW_WMTS_TILE_BOUNDARIES_STORAGE_KEY, enabled ? "1" : "0");
  } catch {}
}

export function isWmtsTileBoundariesDebugEnabled(): boolean {
  return showWmtsTileBoundaries;
}
